import script from "./WCAutoplayCarouselModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCAutoplayCarouselModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCAutoplayCarouselModern.vue?vue&type=style&index=0&id=0385ae7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0385ae7c"]])

export default __exports__